import { call, cancelled, put, takeLatest } from 'redux-saga/effects';
import { apiRequest } from 'utils/request';
import { usersSliceActions as actions } from '.';
import { createRequestSaga } from '../../../../utils/saga';

const loadUsers = createRequestSaga({
  actionType: actions.loadUsersRequest.type,
  onSuccess: function* (response, dataSent) {
    const customers = yield call(loadCustomers);
    yield put(actions.loadUsersSuccess({ ...response, customers }));
  },
  failureAction: actions.loadUsersFailed,
  url: `users`,
  data: p => ({ ...p }),
});

function* loadCustomers() {
  return yield call(apiRequest, {
    url: 'customers',
    method: 'get',
    data: { 'page[size]': 1000 },
  });
}

const loadUser = createRequestSaga({
  actionType: actions.loadUserRequest.type,
  url: p => `users/${p.id}`,
  onSuccess: function* (response, dataSent) {
    const customers = yield call(loadCustomers);
    yield put(actions.loadUserSuccess({ ...response, customers }));
  },
  failureAction: actions.loadUserFailed,
});

const saveUser = createRequestSaga({
  actionType: actions.saveUserRequest.type,
  successAction: actions.saveUserSuccess,
  failureAction: actions.saveUserFailed,
  url: p => (p.id ? `users/${p.id}` : 'users'),
  method: p => (p.id ? 'put' : 'post'),
  data: p => ({ ...p }),
});

const deleteUser = createRequestSaga({
  actionType: actions.deleteUserRequest.type,
  successAction: actions.deleteUserSuccess,
  failureAction: actions.deleteUserFailed,
  url: p => `users/${p.id}`,
  method: 'delete',
  data: p => ({ ...p }),
});

export function* usersSliceSaga() {
  yield takeLatest(actions.loadUsersRequest.type, loadUsers);
  yield takeLatest(actions.loadUserRequest.type, loadUser);
  yield takeLatest(actions.saveUserRequest.type, saveUser);
  yield takeLatest(actions.deleteUserRequest.type, deleteUser);
}
